import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = { duration: { type: Number, default: 4000 } }

  connect() {
    bootstrap.Toast.getInstance(this.element)?.dispose()
    this.toast = new bootstrap.Toast(this.element, {
      autohide: true,
      delay: this.durationValue,
    })
    this.showFrame = requestAnimationFrame(() => this.toast.show())
  }

  disconnect() {
    cancelAnimationFrame(this.showFrame)
    this.toast?.dispose()
  }
}
